import React from 'react';
import { Loading, Button } from '@/components';
import { States } from '@/helpers/common/states';
import Communication from '@/model/Communication';
import { Column, ResponsiveDataGrid } from '@/components/TableReponsive';

interface Props {
  state: States;
  data: Communication[];
  columns: Column<Communication>[];
  onRefresh: () => void;
  onRowClick: (row: Communication) => void;
}

export const CommunicationListUI: React.FC<Props> = ({
  state,
  data,
  columns,
  onRefresh,
  onRowClick,
}): JSX.Element => (
  <>
    <Loading isVisible={state === States.loading} />

    <div className="d-flex justify-content-center">
      <div
        style={{
          width: '100%',
          maxWidth: '100%',
          padding: '12px 10px',
        }}
      >
        <div
          className="bg-white shadow-sm"
          style={{
            borderRadius: 15,
            padding: 24,
          }}
        >
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4">
            <div>
              <h2
                style={{
                  fontSize: 34,
                  fontWeight: 800,
                  marginBottom: 6,
                  color: '#4d4f50',
                }}
              >
                Campanhas cadastradas
              </h2>
              <div style={{ color: '#6b7280', fontWeight: 500 }}>
                Visualize e gerencie as campanhas de comunicação.
              </div>
            </div>

            <div className="d-flex gap-2">
              <Button title="Atualizar" theme="outlineDark" onClick={onRefresh} />
            </div>
          </div>

          <ResponsiveDataGrid
            columns={columns}
            data={data}
            emptyMessage="Nenhuma campanha encontrada."
            initialSortKey="name"
            initialSortDir="asc"
            onRowClicked={onRowClick}
          />
        </div>
      </div>
    </div>
  </>
);
